__turbopack_context__.v({
  "checkoutHeading": "cVZqGG_checkoutHeading",
  "description": "cVZqGG_description",
  "title": "cVZqGG_title",
});
